import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Button from 'Flow2/components/UI/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';
import classes from './ClipDetailsToolbar.module.scss';
import MetadataPermissionHelper from 'Flow2/util/MetadataPermissionHelper.js';
import * as Controls from 'Flow2/config/Controls';
import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import Swal from 'sweetalert2';
import ClipUtil from 'Flow2/util/Clip';
import MediaFile from 'Flow2/util/MediaFile';
import { injectIntl, FormattedMessage } from 'react-intl';
import * as actions from 'store/actions/index';
import { updateHistoryData, refreshCurrentData, isTranscoder1, isOriginTranscoder1 }
    from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { CustomTableLargeTitle } from 'Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox';
import CustomHelpers from 'Flow2/components/CustomCollections/CustomHelpers/CustomHelpers';
import AiBox from "Flow2/components/Ai/AiBox/AiBox";

/*
export const downloadHandler = (props, clip) => {
    const downloadList = ClipUtil.getDownloadList(clip);

    if (clip && downloadList) {
        let list = {};

        console.log(clip);
        
        if (MediaFile.isImage(clip.mainmediafile.data)) {
            for(let key in downloadList) {
                downloadList[key].information = "Source " + downloadList[key].information;
            }
            downloadList.push({ information: "High " + MediaFile.getCorrectAspectRatio(clip.mainmediafile.data, 3072), data: { url: clip.mainthumbnail.replace('.cgi?', '.cgi?cache=0&width=3072&height=3072&download=1&') } });
            downloadList.push({ information: "Medium " + MediaFile.getCorrectAspectRatio(clip.mainmediafile.data, 2048), data: { url: clip.mainthumbnail.replace('.cgi?', '.cgi?cache=0&width=2048&height=2048&download=1&') } });
            downloadList.push({ information: "Low " + MediaFile.getCorrectAspectRatio(clip.mainmediafile.data, 1024), data: { url: clip.mainthumbnail.replace('.cgi?', '.cgi?cache=0&width=1024&height=1024&download=1&') } });
        }
        
        console.log(downloadList);

        downloadList.forEach((elm, index) => {
            list[index] = elm.information;
        });

        Swal.fire({
            title: props.intl.formatMessage({ id: "popup.title.download" }),
            text: props.intl.formatMessage({ id: "popup.message.download.select" }),
            showCancelButton: true,
            confirmButtonText: props.intl.formatMessage({ id: "common.ok" }),
            cancelButtonText: props.intl.formatMessage({ id: "common.cancel" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false,
            input: 'select',
            inputOptions: list
        }).then((result) => {
            if (result.value) {
                let url = downloadList[result.value].data.url;
                if (url) {
                    window.location = url;
                    if (props.customHistory.showHistory && props.customHistory.showHistory.clipid) {
                        let updatedHistory = updateHistoryData(props.user.id, CustomTypes.DOWNLOAD);
                        let currentData = refreshCurrentData(props.customHistory.showHistory, updatedHistory);
                        if (updatedHistory) props.updateMetadata("clip", props.customHistory.showHistory.clipid, { history: updatedHistory });
                        if (currentData) props.setCustomHistory({ showHistory: { ...currentData } });
                    }
                }
            }
        });
    } else {
        Swal.fire({
            title: props.intl.formatMessage({ id: "popup.title.download" }),
            text: props.intl.formatMessage({ id: "popup.message.download.noFile" }),
            type: 'warning',
            confirmButtonText: props.intl.formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            buttonsStyling: false
        });
    }
}
*/



export const downloadHandlerDirect = (url) => {
    //window.location = url;
    window.open(url, '_blank');
}

export const downloadHandlerNoFile = (props) => {
    Swal.fire({
        title: props.intl.formatMessage({ id: "popup.title.download" }),
        text: props.intl.formatMessage({ id: "popup.message.download.noFile" }),
        type: 'warning',
        confirmButtonText: props.intl.formatMessage({ id: "common.ok" }),
        confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
        buttonsStyling: false
    });
}

export const downloadHandlerImage = (props, clip, mediafile) => {
    if (!clip || !clip.mainmediafile) {
        downloadHandlerNoFile(props);
        return;
    }

    const data = clip.mainmediafile.data;
    const downloadList = [];
    const list = {};

    // thumbnail.cgi allways returns jpg images
    // /\.\w*$/gm
    let filename = data.filename.replace(/\.\w*$/gm, "");
    let file = "file=" + data.path + data.filename;

    let url = window.location.origin + "/mfc/thumbnail.cgi?";
    //let url = "https://porsche-test.flowcenter.de/mfc/thumbnail.cgi?";

    // sourcefile
    downloadList.push({ information: "Source " + clip.mainmediafile.data.width + "x" + clip.mainmediafile.data.height, data: { url: url + "cache=0&width=" + clip.mainmediafile.data.width + "&height=" + clip.mainmediafile.data.height + "&download=1&dfname=" + filename + "_source.jpg&" + file } });

    // other qualities
    downloadList.push({ information: "High " + MediaFile.getCorrectAspectRatio(clip.mainmediafile.data, 4000), data: { url: url + "cache=0&width=4000&height=4000&download=1&dfname=" + filename + "_highres.jpg&" + file } });
    downloadList.push({ information: "Medium " + MediaFile.getCorrectAspectRatio(clip.mainmediafile.data, 3000), data: { url: url + "cache=0&width=3000&height=3000&download=1&dfname=" + filename + "_midres.jpg&" + file } });
    downloadList.push({ information: "Low " + MediaFile.getCorrectAspectRatio(clip.mainmediafile.data, 2000), data: { url: url + "cache=0&width=2000&height=2000&download=1&dfname=" + filename + "_lowres.jpg&" + file } });

    downloadList.forEach((elm, index) => {
        list[index] = elm.information;
    });

    Swal.fire({
        title: props.intl.formatMessage({ id: "popup.title.download" }),
        text: props.intl.formatMessage({ id: "popup.message.download.select" }),
        showCancelButton: true,
        confirmButtonText: props.intl.formatMessage({ id: "common.ok" }),
        cancelButtonText: props.intl.formatMessage({ id: "common.cancel" }),
        confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
        cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
        buttonsStyling: false,
        input: 'select',
        inputOptions: list
    }).then((result) => {
        if (result.value) {
            let url = downloadList[result.value].data.url;
            if (url) {
                //window.location = url;
                window.open(url, '_blank');
                if (props.customHistory && props.customHistory.showHistory && props.customHistory.showHistory.clipid) {
                    let updatedHistory = updateHistoryData(props.user.id, CustomTypes.DOWNLOAD);
                    let currentData = refreshCurrentData(props.customHistory.showHistory, updatedHistory);
                    if (updatedHistory) props.updateMetadata("clip", props.customHistory.showHistory.clipid, { history: updatedHistory });
                    if (currentData) props.setCustomHistory({ showHistory: { ...currentData } });
                }
            }
        }
    });
}

export const downloadHandlerStandard = (props, clip, mediafile) => {
    const downloadList = ClipUtil.getDownloadList(clip);

    if (!clip || !downloadList) {
        downloadHandlerNoFile(props);
        return;
    }

    let list = {};

    downloadList.forEach((elm, index) => {
        list[index] = elm.information;
    });

    Swal.fire({
        title: props.intl.formatMessage({ id: "popup.title.download" }),
        text: props.intl.formatMessage({ id: "popup.message.download.select" }),
        showCancelButton: true,
        confirmButtonText: props.intl.formatMessage({ id: "common.ok" }),
        cancelButtonText: props.intl.formatMessage({ id: "common.cancel" }),
        confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
        cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
        buttonsStyling: false,
        input: 'select',
        inputOptions: list
    }).then((result) => {
        if (result.value) {
            let url = downloadList[result.value].data.url;
            if (url) {
                if (props.config && props.config._TOKEN_) {
                    url += "?token=" + props.config._TOKEN_;
                }
                //window.location = url;
                window.open(url, '_blank');

                if (props.customHistory && props.customHistory.showHistory && props.customHistory.showHistory.clipid) {
                    let updatedHistory = updateHistoryData(props.user.id, CustomTypes.DOWNLOAD);
                    let currentData = refreshCurrentData(props.customHistory.showHistory, updatedHistory);
                    if (updatedHistory) props.updateMetadata("clip", props.customHistory.showHistory.clipid, { history: updatedHistory });
                    if (currentData) props.setCustomHistory({ showHistory: { ...currentData } });
                }
            }
        }
    });
}

export const downloadHandler = (props, clip, mediafile) => {
    if (MediaFile.isImage(clip.mainmediafile.data)) {
        downloadHandlerImage(props, clip, mediafile);
    } else {
        downloadHandlerStandard(props, clip, mediafile);
    }
}

const clipDetailsToolbar = (props) => {
    let showPrevNext = false;
    let pos = 0;

    if (props.clip && props.clips) {
        showPrevNext = true;

        props.clips.forEach((clip, index) => {
            if (parseInt(clip.id) === parseInt(props.clip.id)) {
                pos = index;
            }
        });
    }

    const prevHandler = () => {
        if (pos > 0) {
            pos--;
            locationHandler(pos);
        }
    };

    const nextHandler = () => {
        if (pos < (props.clips.length - 1)) {
            pos++;
            locationHandler(pos);
        }
    };

    const locationHandler = (pos) => {
        let ids = (props.location.state && props.location.state.clips) ? props.location.state.clips : [];
        let back = (props.location.state && props.location.state.back) ? (props.location.state.back + 1) : 1;
        let clip = props.clips[pos];

        const remoteId = clip.originalObject.remoteserverdevice ? clip.originalObject.remoteserverdevice + "0" : "";
        props.setCurrentClip(props.allClips[remoteId + clip.id]);

        props.history.push({
            pathname: props.match.path + "/" + clip.id,
            component: 'Clipdetails',
            state: { id: clip.id, clips: ids, back: back }
        });
    }

    const goBackHandler = () => {
        if (props.from) {
            props.setCurrentClip(props.from);
        }
        if (props.location.state && props.location.state.back) {
            props.history.go(-(1 + props.location.state.back));
        } else {
            props.history.goBack();
        }
    }

    const dragStartHandler = (event, clipId) => {
        event.dataTransfer.dropEffect = "move";
        event.dataTransfer.setData("text/plain", clipId);
        props.onDragStart(clipId);
    }

    return (
        <div className={classes.CustomClipDetailsToolbarSection}>
            <div className={classes.CustomClipDetailsToolbarContainer}>
                <div className={classes.CustomTitleButtonsGroupLeft}>
                    <div className={classes.CustomButtonsBoxLeft} >
                        <CustomHelpers type="deletedItemsWrapper" currentItem={props.clip} >
                            <Button
                                btnType="White"
                                clicked={goBackHandler}
                                title={props.intl.formatMessage({ id: "page.clipdetail.toolbar.back" })}
                                additionalClass="text_ellipsis">
                                <FontAwesomeIcon icon="undo" /><FormattedMessage id="page.clipdetail.toolbar.back" />
                            </Button>
                        </CustomHelpers>
                        {
                            showPrevNext ?
                                <>
                                    <Button
                                        btnType="White"
                                        disabled={(pos <= 0)}
                                        clicked={() => { prevHandler() }}
                                        title={props.intl.formatMessage({ id: "page.clipdetail.toolbar.prev" })}
                                        additionalClass={["text_ellipsis", "no_margin", classes.bigger].join(' ')}>
                                        <FontAwesomeIcon icon="chevron-left" />
                                    </Button>
                                    <Button
                                        btnType="White"
                                        disabled={(pos >= (props.clips.length - 1))}
                                        clicked={() => { nextHandler() }}
                                        title={props.intl.formatMessage({ id: "page.clipdetail.toolbar.next" })}
                                        additionalClass={["text_ellipsis", "no_margin", classes.bigger].join(' ')}>
                                        <FontAwesomeIcon icon="chevron-right" />
                                    </Button>
                                </>
                                : ""
                        }
                        <span
                            className={[classes.DragDrop, "text_ellipsis"].join(' ')}
                            draggable="true"
                            onDragStart={(e) => { dragStartHandler(e, props.clip.id); }}
                            title={props.intl.formatMessage({ id: "page.clipdetail.toolbar.dragDrop" })}
                        >
                            <FormattedMessage id="page.clipdetail.toolbar.dragDrop" />
                        </span>
                    </div>
                </div>
                <div className={classes.CustomTitleTexGroupMiddle} >
                    <CustomTableLargeTitle key={props.title} data={props.title} />
                </div>
                <div className={classes.CustomTitleButtonsGroupRight}>
                    {<AiBox isClipDetail={true} />}
                    {
                        MetadataPermissionHelper.hasFieldPermission({ ...props, originalObject: props.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "download") && MetadataPermissionHelper.showControl(props.config, Controls.CTL_DOWNLOAD) ?
                            <Button
                                btnType="Dark"
                                clicked={() => downloadHandler(props, props.clip)}
                                additionalClass={["text_ellipsis", classes.fitContent].join(' ')}>
                                <FontAwesomeIcon icon="arrow-down" /> <FormattedMessage id="page.clipdetail.toolbar.download" />
                            </Button> : ""
                    }
                    {
                        (MetadataPermissionHelper.hasPermission({ type: metadata.OBJECT_TYPE_CLIP, originalObject: props.originalObject, ...props })) ?
                            <Button btnType={props.editBtn.style || "Dark"}
                                clicked={props.onEdit}
                                title={props.intl.formatMessage({ id: props.editBtn.text })}
                                additionalClass={["text_ellipsis", classes.fitContent].join(' ')}>
                                <FontAwesomeIcon icon={props.editBtn.icon} />&nbsp;&nbsp;<FormattedMessage id={props.editBtn.text} />
                            </Button> : ""

                    }
                    <Button
                        btnType="Dark"
                        clicked={props.onLang}
                        additionalClass={["text_ellipsis", classes.fitContent].join(' ')}>
                        {props.langBtn}
                    </Button>

                    {
                        MetadataPermissionHelper.hasDeletePermission({ type: metadata.OBJECT_TYPE_CLIP, ...props }) ?
                            <Button
                                btnType="Dark"
                                clicked={props.onMoveToTrash}
                                title={props.intl.formatMessage({ id: "page.clipdetail.toolbar.delete" })}
                                additionalClass={["text_ellipsis", "no_margin", classes.fitContent].join(' ')}>
                                <FontAwesomeIcon icon={faTrash} className="" />
                            </Button> : ""
                    }
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    let clips = [];
    if (ownProps.location.state && ownProps.location.state.clips) {
        ownProps.location.state.clips.forEach(id => {
            clips.push(state.clipList.clips[id]);
        });
    } else if (ownProps.location.clips) {
        clips = ownProps.location.clips;
    }

    let from = null;
    if (ownProps.location.state && ownProps.location.state.from) {
        from = state.clipList.clips[ownProps.location.state.from];
    }

    return {
        clips: clips,
        from: from,
        user: state.auth.user,
        config: state.ui.config,
        lang: state.ui.language,
        customHistory: state.customData.customHistory,
        allClips: state.clipList.clips
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentClip: (clip) => dispatch(actions.selectClip(clip)),
        updateMetadata: (type, id, metadata) => dispatch(actions.updateMetadata(type, id, metadata)),
        setCustomHistory: (currentHistory) => dispatch(actions.setCustomHistory(currentHistory)),
        onDragStart: (clipId) => dispatch(actions.clipDragStart(clipId))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(clipDetailsToolbar)));
